const ITEMS = [
  {
    tag: "01",
    icon: "ri-shield-check-line",
    title: "Diversified Capital · Zero Single-Point Risk",
    desc: "Automated portfolio strategy allocates capital across 58+ partner farms. No single farm fluctuation can significantly impact overall returns.",
    highlight: "68% lower volatility than industry average",
    tone: "primary",
  },
  {
    tag: "02",
    icon: "ri-line-chart-line",
    title: "Stable Returns · Predictable Long-Term",
    desc: "Based on actual farm output, settled quarterly and trackable monthly. No promises, no hype — just real production converted into your returns.",
    highlight: "Positive monthly returns over the past 24 months",
    tone: "accent",
  },
  {
    tag: "03",
    icon: "ri-hand-coin-line",
    title: "Profit Sharing · Members First",
    desc: "The platform retains only essential operational and farm coordination costs. The vast majority of profits are automatically returned to online members by share.",
    highlight: "80% net profit distributed to members",
    tone: "secondary",
  },
  {
    tag: "04",
    icon: "ri-eye-line",
    title: "Full Transparency · Data Accessible",
    desc: "Real-time farm monitoring data, individual cow profiles, quarterly audit reports, and capital flows — members can access everything anytime. Zero black boxes.",
    highlight: "Third-party quarterly audits",
    tone: "primary",
  },
];

const toneMap: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export default function Advantage() {
  return (
    <section id="advantage" className="w-full bg-background-100/60">
      <div className="w-full px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide">
            <i className="ri-sparkling-line"></i>
            Why CCF
          </div>
          <h2
            className="mt-5 text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            Why Dairy Enthusiasts Worldwide Choose <span className="text-primary-600">CCF</span>
          </h2>
          <p className="mt-5 text-sm md:text-lg text-foreground-700 leading-relaxed">
            We've tackled the three toughest challenges in traditional farming — risk, transparency, and returns — with a sustainable system.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.tag}
              className="group relative p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between">
                <div
                  className={[
                    "w-12 h-12 flex items-center justify-center rounded-xl",
                    toneMap[item.tone],
                  ].join(" ")}
                >
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <span
                  className="text-5xl font-heading text-background-300 group-hover:text-primary-300 transition-colors"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {item.tag}
                </span>
              </div>

              <h3 className="mt-6 text-xl md:text-2xl font-heading font-semibold text-foreground-950"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {item.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                {item.desc}
              </p>

              <div className="mt-6 flex items-center gap-2 text-xs font-semibold text-primary-700">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-check-line"></i>
                </span>
                {item.highlight}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}